import { render, staticRenderFns } from "./MegaMenuFilterPanel.vue?vue&type=template&id=4f5f6158&scoped=true&"
import script from "./MegaMenuFilterPanel.vue?vue&type=script&lang=js&"
export * from "./MegaMenuFilterPanel.vue?vue&type=script&lang=js&"
import style0 from "./MegaMenuFilterPanel.vue?vue&type=style&index=0&id=4f5f6158&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5f6158",
  null
  
)

export default component.exports